var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { EventCountCommand } from '../../../../commands/accounts/create.account.command';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import { ConfirmModalActions, ConfirmModalData } from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { ModalService } from '../../../../common/services/modal.service';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { ShowPlacesCountModalData } from './show.places.count.modal.provider';
var ShowPlacesCountModalComponent = /** @class */ (function (_super) {
    __extends(ShowPlacesCountModalComponent, _super);
    function ShowPlacesCountModalComponent(fb, accountApiService, modalService, alertify, dialogRef, data) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.accountApiService = accountApiService;
        _this.modalService = modalService;
        _this.alertify = alertify;
        _this.dialogRef = dialogRef;
        _this.loading = false;
        _this.total = 0;
        _this.approved = 0;
        _this.unApproved = 0;
        _this.eventCount = new EventCountCommand();
        _this.account = Object.assign({}, data);
        return _this;
    }
    ShowPlacesCountModalComponent.prototype.ngOnInit = function () {
        this.loading = true;
        // this.accountApiService.getPlaceCount(this.account.account.userName)
        //     .finally(() => {
        //         this.loading = false;
        //     })
        //     .subscribe((count) => {
        //         if (count && !isNullOrUndefined(count.total) && !isNullOrUndefined(count.approved) && !isNullOrUndefined(count.unApproved)) {
        //             this.total = count.total;
        //             this.approved = count.approved;
        //             this.unApproved = count.unApproved;
        //         }
        //     });
        this.getItemCount();
        this.getEventCount();
        // this.getEditorChoiceCount();
    };
    ShowPlacesCountModalComponent.prototype.getEventCount = function () {
        var _this = this;
        this.accountApiService.getEventCount(this.account.account.userName).subscribe(function (count) {
            _this.eventCount = count;
        });
    };
    ShowPlacesCountModalComponent.prototype.getEditorChoiceCount = function () {
        var _this = this;
        this.accountApiService.getEditorChoiceCount(this.account.account.userName).subscribe(function (count) {
            _this.editorChoiceCount = count;
        });
    };
    ShowPlacesCountModalComponent.prototype.getItemCount = function () {
        var _this = this;
        this.accountApiService.getItemCount(this.account.account.userName).subscribe(function (count) {
            console.log(count);
            _this.itemCount = count;
            _this.itemCount.pdfHistory.forEach(function (x) {
                x.exportTime = new Date(x.exportTime).toLocaleString();
            });
            _this.loading = false;
        });
    };
    ShowPlacesCountModalComponent.prototype.deletePlaces = function ($event) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.accountApiService.removePlaces(_this.account.account._id)
                    .finally(function () {
                    event.complete();
                    $event.complete();
                })
                    .subscribe(function () {
                    _this.alertify.successfully('Remove all places for this account');
                    _this.close();
                });
            },
            cancel: function () {
                $event.complete();
            }
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: "Are you sure you want to delete all places for " + this.account.account.userName + ", this cannot be reverted?",
            confirmModalConfirmButtonText: 'Delete',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data }
            ]
        });
    };
    ShowPlacesCountModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    return ShowPlacesCountModalComponent;
}(BaseComponent));
export { ShowPlacesCountModalComponent };
var ItemCount = /** @class */ (function () {
    function ItemCount() {
    }
    return ItemCount;
}());
export { ItemCount };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/show.places.count/show.places.count.modal.component.ts.pre-build-optimizer.js